<template>
    <div class="ota_search_index">
        <!-- 标题 -->
        <div class="search_title">
            <div class="search_title_text">OTA搜索</div>
            <div class="search_title_border">
                <div class="bread_crumbs_before_left"></div>
                <div class="bread_crumbs_before_right"></div>
            </div>
        </div>
        <!-- 搜索框 -->
        <div class="search_leaf_node">
            <input 
                type="text" 
                v-model="search_val" 
                placeholder="请输入OTA关键字"
                @keyup.enter="searchFn"
            />
            <div class="search_leaf_button" @click="searchFn"></div>
        </div>

        <!-- 搜索结果列表 -->
        <div class="ota-detail-list" v-if="searchResult.length">
            <div class="detail-list">
                <div class="detail-item" v-for="(item, index) in searchResult" :key="item.id">
                    <div class="detail-item-title">{{ index + 1 }}.{{ item.intro }}</div>
                    <div class="detail-content">{{ item.content }}</div>
                    <div class="detail-item-main">
                        <el-image 
                            v-for="img in item.attachment" 
                            class="detail-img" 
                            :src="img.link_url"
                            :key="img.id" 
                            :preview-src-list="[img.link_url]" 
                            fit="cover" 
                        />
                    </div>
                    <div class="detail-item-model">
                        <div>{{ item.brand.name }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.model }}</div>
                        <div class="detail-item-model-date">{{ item.published }}</div>
                    </div>
                    <div class="sp-line"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { ElMessage, ElImage } from 'element-plus'
import { getOtaSearch } from '@/api'

export default {
    components: {
        ElImage
    },
    name: 'OtaSearchIndex',
    setup() {
        const search_val = ref('')
        const loading = ref(false)
        const searchResult = ref([])

        const searchFn = () => {
            if (!search_val.value.trim()) {
                ElMessage.warning("请输入搜索内容！")
                return
            }
            loading.value = true
            
            getOtaSearch({
                keyword: search_val.value
            }).then(res => {
                searchResult.value = res.data.list || []
                loading.value = false
            }).catch(() => {
                loading.value = false
            })
        }

        return {
            search_val,
            loading,
            searchResult,
            searchFn
        }
    }
}
</script>

<style lang="less" scoped>
.ota_search_index {
    width: 1200px;
    background: #fff;
    padding: 20px 40px;
    min-height: calc(100vh - 100px);

    .search_title {
        position: relative;
        height: 46px;
        line-height: 46px;
        .search_title_text {
            font-size: 14px;
            font-weight: bold;
            color: #0E0A31;
            text-align: center;
        }
        .search_title_border {
            display: flex;
            align-items: center;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            .bread_crumbs_before_left {
                width: 28px;
                height: 2px;
                background: #1FBCBF;
            }
            .bread_crumbs_before_right {
                width: 27px;
                height: 2px;
                background: #DCDCDC;
            }
        }
    }

    .search_leaf_node {
        margin: 30px auto 10px;
        width: 692px;
        height: 52px;
        border-radius: 2px;
        border: 1px solid #DEDEDE;
        background-position: 179px center;
        display: flex;
        align-items: center;
        font-size: 16px;

        input {
            width: 100%;
            height: 100%;
            appearance: none;
            outline: none;
            border: none;
            background: transparent;
            padding: 0 10px 0 30px;
            font-size: 14px;
            &::placeholder{
                color: #bebebe;
            }
        }

        &:has(input:focus){
            border: 1px solid #1FBCBF;
        }

        .search_leaf_button {
            width: 50px;
            height: 100%;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png)
                no-repeat center center;
            background-size: 17px 17px;
            cursor: pointer;
        }
    }
}

.ota-detail-list {
    margin-top: 50px;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
}

.detail-list {
    max-width: 1080px;
}

.detail-content {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #404248;
    font-style: normal;
    margin-top: 12px;
}

.detail-img {
    margin-top: 16px;
    height: 140px;
    margin-right: 25px;
}

.detail-item-main {
    display: flex;
}

.sp-line {
    height: 1px;
    width: 100%;
    background: #d0d0d0;
    margin: 20px 0;
    opacity: 0.5;
}

.detail-item-model {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #8b909d;
    font-style: normal;
    margin-top: 10px;
    width: 600px;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}
</style>